import styled from '@emotion/styled';

export const StyledFormCheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
